import { Component, OnChanges, OnInit, OnDestroy, Input, Output, EventEmitter, SimpleChanges, SimpleChange } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog, MatSnackBar } from '@angular/material';
import { LoginService } from 'src/app/managers/login.service';
import { ClientConfigService } from 'src/app/common/services/client-config.service';
import { BaseComponent } from 'src/app/common/components/base/base.component';
import { CoreResponseStatus } from 'src/app/contracts/responseMessage/coreResponseMessage';
import { RssFeedService } from 'src/app/managers/rssFeed.service';
import { ChannelItem } from 'src/app/models/channel_item';
import { OrderBy } from 'src/app/repositories/base.repository';
import { Channel } from 'src/app/models/channel';
import { Store, UnsubscribeCallback } from 'src/app/store/store';
import { DisplayModeActionType, SubscriptionDisplayModeActionType } from 'src/app/store/reducers';

@Component({
  selector: 'app-today-feed-items',
  templateUrl: './today-feed-items.component.html',
  styleUrls: ['./today-feed-items.component.css']
})
export class TodayFeedItemsComponent extends BaseComponent implements OnChanges, OnInit, OnDestroy {  
  private _channel: Channel;
  @Output() onFavoriteItemAdded: EventEmitter<ChannelItem>;
  @Output() onFavoriteItemRemoved: EventEmitter<ChannelItem>;
  displayMode: DisplayModeActionType;
  itemImageWidth: string;
  itemImageHeight: string;
  cardSizeWidth: string;
  cardSizeHeight: string;
  isLoading: boolean;
  loadingStr: string;
  private _onInitCalled: boolean;
  private _channelStoreUnsubscribe: UnsubscribeCallback;
  private _displayModeStoreUnsubscribe: UnsubscribeCallback;

  constructor(route: ActivatedRoute, loginManager: LoginService, clientConfig: ClientConfigService, dialog: MatDialog, private _feedManager: RssFeedService,
              private _snackBar: MatSnackBar, private _store: Store) { 
    super(route, loginManager, clientConfig, dialog);
    this.isLoading = false;
    this._onInitCalled = false;

    this._channelStoreUnsubscribe = this._store.subscribeChannelState(() => {
      if (this._store.getSubscriptionDisplayModeState() === SubscriptionDisplayModeActionType.Grid) {
        this._channel = this._store.getChannelState();
        this.loadChannelItemsAsync();
      }      
    });

    this._displayModeStoreUnsubscribe = this._store.subscribeDisplayModeState(() => {
      this.displayMode = this._store.getDisplayModeState();

      if (this.displayMode === DisplayModeActionType.Favorite)
        this.loadFavoriteItemsAsync();
      else if (this.displayMode === DisplayModeActionType.Today)
        this.loadTodayFeedItemsAsync();
    });    

    this.onFavoriteItemAdded = new EventEmitter<ChannelItem>();
    this.onFavoriteItemRemoved = new EventEmitter<ChannelItem>();
  }

  ngOnChanges(changes: SimpleChanges) {
    /*
    for (let propName in changes) {
      if (propName === 'channel') {
        let change = changes[propName];

        if (this.isChannelChanged(change)) {
          if (this._onInitCalled) {
            if (this.displayMode === DisplayModeActionType.Subscription)
              this.loadChannelItemsAsync();
          }
        }
      }
      else if (propName === 'displayMode') {
        let change = changes[propName];

        if (this.isDisplayModeChanged(change)) {
          if (this._onInitCalled) {
            if (this.displayMode === 'today')
              this.loadTodayFeedItemsAsync();
            else if (this.displayMode === 'favorite')
              this.loadFavoriteItemsAsync();
          }
        }
      }
    }
    */
  }

  ngOnInit() {
    this._onInitCalled = true;
    this.itemImageWidth = "280px";
    this.itemImageHeight = "220px";
    this.cardSizeWidth = "280px";
    this.cardSizeHeight = "320px";
    this._channel = this._store.getChannelState();

    if (this._store.getDisplayModeState() === DisplayModeActionType.Favorite)
      this.loadFavoriteItemsAsync();
    else if (this._store.getDisplayModeState() === DisplayModeActionType.Today)
      this.loadTodayFeedItemsAsync();
    else if (this._store.getDisplayModeState() === DisplayModeActionType.Subscription && this._store.getSubscriptionDisplayModeState() === SubscriptionDisplayModeActionType.Grid)
      this.loadChannelItemsAsync();
    else 
      this.loadTodayFeedItemsAsync();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this._channelStoreUnsubscribe();
    this._displayModeStoreUnsubscribe();    
  }

  favoriteItemAdded(channelItem) {
    this.onFavoriteItemAdded.emit(channelItem);
  }

  async removeFavoriteItem(channelItem) {
    let coreRespMsg = await this._feedManager.removeChannelItemFromFavoriteAsync(this.getLoggedinUser(), channelItem);

    if (coreRespMsg.Status === CoreResponseStatus.OK) {
      let remainedItems = this.dataSource.filter(x => x.Id !== channelItem.Id);
      this.dataSource = remainedItems;
      this.onFavoriteItemRemoved.emit(channelItem);
      this._snackBar.open('The item has been removed.', 'OK', { duration: this._successMsgDuration });
    }
    else {
      this._snackBar.open('Failed to remove the channel item: ' + coreRespMsg.Message, 'OK', { duration: this._failMsgDuration });
    }
  }

  isFavoriteDisplayMode(): boolean {
    return this.displayMode === DisplayModeActionType.Favorite;
  }

  private async loadTodayFeedItemsAsync() {
    this.loadingStr = "Loading today's feeds...";
    this.isLoading = true;
    let responseMsg = await this._feedManager.getTodayFeedItemsAsync(0, 0, 'Tags', 'ASC');
    this.isLoading = false;

    if (responseMsg.Status === CoreResponseStatus.OK) {
      this.dataSource = responseMsg.Result;
    }
    else {
      if (responseMsg.Status !== CoreResponseStatus.NoData) {
        this._snackBar.open("Failed to load today's feeds: " + responseMsg.Message, 'OK', { duration: this._failMsgDuration });
        this.handleCoreResponseMessageError(responseMsg);
      }

      this.dataSource = null;
    }
  }

  private async loadFavoriteItemsAsync() {
    this.loadingStr = 'Loading bookmark feeds...';
    this.isLoading = true;
    let responseMsg = await this._feedManager.getFavoriteItemsAsync(this.getLoggedinUser(), 0, 0, 'PublishDate', OrderBy.DESC.toString());
    this.isLoading = false;

    if (responseMsg.Status === CoreResponseStatus.OK)
      this.dataSource = responseMsg.Result;                
    else {
      if (responseMsg.Status !== CoreResponseStatus.NoData) {
        this._snackBar.open('Failed to load feeds: ' + responseMsg.Message, 'OK', { duration: this._failMsgDuration });
        this.handleCoreResponseMessageError(responseMsg);
      }
      
      this.dataSource = null;
    } 
  }

  private async loadChannelItemsAsync() {
    this.loadingStr = 'Loading feeds...';
    this.isLoading = true;
    let responseMsg = await this._feedManager.loadRssItemsAsync(this.getLoggedinUser(), this._channel);
    this.isLoading = false;

    if (responseMsg.Status === CoreResponseStatus.OK) {
      this.dataSource = responseMsg.Result;

      this.dataSource.map(item => {
        item.Tags = this._channel.Title;
      });
    }
    else {
      if (responseMsg.Status !== CoreResponseStatus.NoData) {
        this._snackBar.open('Failed to retrieve subscription items: ' + responseMsg.Message, 'OK', { duration: this._failMsgDuration });
        this.handleCoreResponseMessageError(responseMsg);
      }

      this.dataSource = null;
    }
  }

  private isChannelChanged(change: SimpleChange): boolean {
    let update: boolean = false;
    let prevChannel: Channel = change.previousValue;
    let currChannel: Channel = change.currentValue;
    
    if (currChannel !== undefined) {
      if (prevChannel === undefined)
        update = true;
      else if (prevChannel.Title !== currChannel.Title)
        update = true;
    }

    return update;
  }

  private isDisplayModeChanged(change: SimpleChange): boolean {
    let update: boolean = false;
    let prevValue: string = change.previousValue;
    let currValue: string = change.currentValue;

    if (!this.undefinedOrNull(currValue)) {
      if(this.undefinedOrNull(prevValue))
        update = true;
      else if (prevValue !== currValue)
        update = true;
    }

    return update;
  }
}
